/* ss-instagram.js - arrows on desktop, on-site lightbox with prev/next, reel playback on demand. */
(function () {
  'use strict';
  document.querySelectorAll('[data-ss-ig]').forEach(init);

  function init(root) {
    var row = root.querySelector('[data-ss-ig-row]');
    var posts = [];
    try { posts = JSON.parse(root.querySelector('[data-ss-ig-data]').textContent); } catch (e) { return; }
    var t = { open: root.dataset.tOpen, close: root.dataset.tClose, prev: root.dataset.tPrev, next: root.dataset.tNext, reel: root.dataset.tReel };
    var user = root.dataset.username;

    // arrows (desktop only via CSS) -------------------------------------------------------------
    var arrows = root.querySelectorAll('[data-ss-ig-scroll]');
    function syncArrows() {
      var max = row.scrollWidth - row.clientWidth - 2;
      arrows.forEach(function (b) {
        var dir = +b.dataset.ssIgScroll;
        b.hidden = max <= 0;
        b.disabled = dir < 0 ? row.scrollLeft <= 2 : row.scrollLeft >= max;
      });
    }
    arrows.forEach(function (b) {
      b.addEventListener('click', function () {
        row.scrollBy({ left: +b.dataset.ssIgScroll * Math.max(row.clientWidth * 0.8, 200), behavior: 'smooth' });
      });
    });
    row.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();

    // lightbox --------------------------------------------------------------------------------
    var dlg, mediaEl, capEl, timeEl, outEl, prevBtn, nextBtn, cur = 0;
    var acct = root.querySelector('.ss-ig__acct');   // the header's profile picture + name + verified badge, reused in the lightbox
    function build() {
      dlg = document.createElement('dialog');
      dlg.className = 'ss-ig__lb';
      dlg.innerHTML =
        '<div class="ss-ig__card">' +
          '<button type="button" class="ss-ig__x" data-close aria-label="' + esc(t.close) + '"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
          '<button type="button" class="ss-ig__nav ss-ig__nav--prev" data-nav="-1" aria-label="' + esc(t.prev) + '"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<button type="button" class="ss-ig__nav ss-ig__nav--next" data-nav="1" aria-label="' + esc(t.next) + '"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="ss-ig__media"></div>' +
          '<div class="ss-ig__body">' +
            '<div class="ss-ig__who"><span class="ss-ig__who-acct">' + (acct ? acct.innerHTML : '<b>' + esc(user) + '</b>') + '</span><time></time></div>' +
            '<p class="ss-ig__cap"></p>' +
            '<a class="ss-ig__out" target="_blank" rel="noopener"><span></span><svg viewBox="0 0 24 24"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>' +
          '</div>' +
        '</div>';
      document.body.appendChild(dlg);
      var av = dlg.querySelector('.ss-ig__avatar'); if (av) av.loading = 'eager';
      mediaEl = dlg.querySelector('.ss-ig__media'); capEl = dlg.querySelector('.ss-ig__cap'); timeEl = dlg.querySelector('time');
      outEl = dlg.querySelector('.ss-ig__out'); outEl.querySelector('span').textContent = t.open;
      prevBtn = dlg.querySelector('[data-nav="-1"]'); nextBtn = dlg.querySelector('[data-nav="1"]');
      dlg.querySelector('[data-close]').addEventListener('click', close);
      prevBtn.addEventListener('click', function () { show(cur - 1); });
      nextBtn.addEventListener('click', function () { show(cur + 1); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });   // backdrop
      dlg.addEventListener('close', stopVideo);
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(cur - 1);
        else if (e.key === 'ArrowRight') show(cur + 1);
      });
      var x0 = null;
      mediaEl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      mediaEl.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
      });
    }
    function stopVideo() { var v = mediaEl && mediaEl.querySelector('video'); if (v) { v.pause(); v.removeAttribute('src'); v.load(); } }
    function show(i) {
      if (i < 0 || i >= posts.length) return;
      cur = i; var p = posts[i]; stopVideo();
      var sep = p.image.url.indexOf('?') > -1 ? '&' : '?';
      var dim = (p.type === 'reel' && p.video && p.video.width) ? p.video : p.image;
      var r = (dim && dim.width && dim.height) ? dim.width / dim.height : 0.8;
      mediaEl.style.setProperty('--r', r.toFixed(4));
      requestAnimationFrame(function () { var b = mediaEl.getBoundingClientRect(); dlg.style.setProperty('--mw', b.width + 'px'); dlg.style.setProperty('--mh', b.height + 'px'); });
      if (p.type === 'reel' && p.video && p.video.url) {
        mediaEl.innerHTML = '<video controls playsinline preload="metadata" poster="' + esc(p.image.url + sep + 'width=1080') + '" src="' + esc(p.video.url) + '" aria-label="' + esc(t.reel) + '"></video>';
        var v = mediaEl.querySelector('video');
        // The tap on the tile is the user gesture, so sound is allowed on desktop. iOS may still refuse
        // un-muted autoplay - then start muted (the controls let the viewer unmute) instead of showing a frozen poster.
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play().catch(function () {}); });
      } else {
        mediaEl.innerHTML = '<img src="' + esc(p.image.url + sep + 'width=1080') + '" alt="">';
      }
      capEl.textContent = p.caption || '';
      var d = new Date(p.timestamp); timeEl.dateTime = p.timestamp;
      timeEl.textContent = isNaN(d) ? '' : d.toLocaleDateString(document.documentElement.lang || 'nb', { day: 'numeric', month: 'long', year: 'numeric' });
      outEl.href = p.permalink;
      prevBtn.disabled = i === 0; nextBtn.disabled = i === posts.length - 1;
    }
    function open(i) { if (!dlg) build(); show(i); if (!dlg.open) dlg.showModal(); }
    function close() { if (dlg && dlg.open) dlg.close(); }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ss-ig-open]'); if (b) open(+b.dataset.ssIgOpen);
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
})();
